import React from 'react';
import store from './store';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import Passwords from './Passwords';
import Games from './Games';
import NotFoundPage from './NotFoundPage';
import FateItems from './FateItems';
import Gallery from './Gallery';
import Updates from './Updates';
import Playing from './Playing';
import GamesHorror from './GamesHorror';

function Game(id, name, description, difficulty, isBrowser, icon, slides, trailer, character, download, genres, slideDescriptions,background,isNew,order) {
  this.id = id;
  this.name = name;
  this.description = description;
  this.difficulty = difficulty;
  this.isBrowser = isBrowser;
  this.icon = icon;
  this.slides = slides;
  this.trailer = trailer;
  this.character = character;
  this.download = download;
  this.genres = genres;
  this.slideDescriptions = slideDescriptions;
  this.background = background;
  this.isNew = isNew;
  this.order = order;
}

  const xmas = false;
  const halloween = true;
const gameArray = [];

const horrorGameArray = [];

let season = "halloween";


//cardsOfhorrorGames
horrorGameArray.push(new Game(
  1,
  "Kene & Sabrini Cards of Horror",
  `Kenebrini...`,
  10,
  false,
  "kslogohorror",
  "K&S",
  "cardsOfHorror1",
  "kenebrini2",
  "Kene&SabriniCardsOfHorror",
  ["RPG"],
  [` YOU WERE WARNED!!!`,`YOU WERE WARNED!!!`,`YOU WERE WARNED!!!
    `,`YOU WERE WARNED!!!`,`YOU WERE WARNED!!!`,
`YOU WERE WARNED!!!`],
  "crimsonMonarch",
  false,
  1

));

horrorGameArray.push(new Game(
  2,
  "Yume Souls Cards of Horror",
  `Lesbians...`,
  5,
  false,
  "yumeSouls",
  "YS",
  "ys",
  "yume",
  "Yume Souls",
  ["RPG"],
  [` YOU WERE WARNED!!!`,`YOU WERE WARNED!!!`,`YOU WERE WARNED!!!
    `,`YOU WERE WARNED!!!`,`YOU WERE WARNED!!!`,
`YOU WERE WARNED!!!`],
  "yumeBackgorund",
  true,
  2

));





//normalGames
gameArray.push(new Game(
  1,
  "Poof's Killergarten Re|Rattled",
  `Killergarten is a place where children
      can have fun?? What fun is being observed 24/h by security
      cameras and restricted by radical rules. Definitely not Poof's.. Just wait
      for him as he'll change this place into something amazing today!!`,
  2,
  false,
  "pkgrr_logo",
  "KG/Remake",
  "pkg_rr",
  "poof3",
  "Poof's Killergarten RR",
  ["RPG"],
  [` Killergarten is very well
        accomodated place with a 
        very simple and strightforward
        goal. To make it's children safe.
        
 
       Well, things haven't worked as planned
       and the security systems are overprotective
       and sometimes dangerous.

      So the best way to deal with a
      problematic system is to engage
      it in a combat.`,` Killergarten toys live their
     own life, but you can cut it in 
     exchange for some experience.
      
 
      You can encounter toys in almost
      every room and decide rather
      to fight them or leave alone.
       

     Across different places enemies
     will grew in strength so don't forget
     you can do the same and dominate them all.`,`Each party member awaits in
   different place inside the
   facility and has their own
   demands toward the main character
   in order to join him.
    

   While first couple of
   encounters are manageable
   for one character to succeed in.
   Battles are going to be harder
   over time, so more party members equal
   more power.
     

   Each one has different
   weapon to equip and skillset
   suitable for different playstyles
   and roles.`,`There are 65+ achievable
    skills in the whole game.
    
     

   No matter if active or passive,
   each skill feels unique and you're
   the one to make the good use of 
   them.
    

   Over time party members will
   learn new exciting powers, so the 
   playstyle strategies would change
   as well.
    `,`Of course in RPG game There are 
 bosses and this one is no exception.  


Prepare your party and deal with them
in massive combats full of epickness
and emotional drama.
Or just watch how massive damage obliterate
them if you grind too much. 


Aside from that there are a few really powerfull
optional bosses who need a lot of good turn flow,
strategy and sometimes many attempts or just overgrinding
to defeat.`,`Every time you're at the edge of the end
there might be some more hidden parts that
might or might not matter.
The only one to look after those is you.`,
`And the ending that one gets is based
on how much you struggle to get it.

 No matter which result you'll stay on, just
 be proud of it and... nevermind...

 You won't be able to achieve the proper solution,
 i swear...`],
  "pkgrr",
  true,
  3

));
gameArray.push(new Game(
  2,
  "Poof's Killergarten Re|Binded Fate",
  `Killergarten is a place full of fate.. But what happens
      when fate once binded divides?? Definitely nothing good. Join Sonia, Poof, Capcake and Cubus in the
      journey through worlds to finally resolve their fate.`,
  2,
  false,
  "poofbf_logo",
  "DF/Remake",
  "df_ending6",
  "sonia1",
  "Poof's Killergarten RBF",
  ["ROGUELIKE"],
  [`Revisit or meet the place of
        invigilation for few children.
        It's very uncertain what is the goal
        of this place now.
        
    
      Hell, it's better for poof to
      make the place suitable to his
      schemes, but the question is..
      Will he succeed?
        
   
     The rooms aren't physically
     aligned with each other and the
     space is messy.`,`As in Roguelike game, you need to move in order
     to be in good position to hit enemies and
     dodge their attacks.
         
    
        HP is displayed in hearts
        instead of bars and most of the time
        taking damage will take half of one.
          
    
       Map displays your position and
       plenty of rooms, either discovered or 
       unrevealed on the floor.  `,`There are 42+ items in the game,
      active or passive, every of them
      have an ability, some have better, some 
      weaker.
       

      Items are commonly located in special
      rooms on a floor or appear after the bossfight
        
   
      Those are very important and really 
      enhance the progress.`,`Floors have a bunch of collectible pick up
     items, chests, shops and guarded rooms.
     Some rooms containing boulders and spikes on
     the floor.
     

 Through the journey, difficulty raises.

   Be aware of the dangers awaiting every
   room.`,`Of course in Roguelike game There are 
  bosses and this one is no exception.  

Prepare your skills, nerves and gunpowder 
to deal with powerfull bosses each floor.

Outside of casual floor bosses there are final ones
which after defeating give mysterious animated ending
to experience.`,`Each character have their respective
    set of attributes and skills making
    them stand out in terms of playability.

   Defeating lore bosses with characters makes
   their progres sheets closer to completion.`,
  `Are you prepared to face it...?

  Are you strong enough to make through it...?

  If not, so live unaware in the present discarding
  the future.`],
  "aa_pkgnt_void2",
   true,
   8


));
gameArray.push(new Game(
  3,
  "Poof's Killergarten Re|Time",
  `Killergarten is a place that's going to be soon abandoned by Poof and gang as
      their never-ending pursuit of freedom continues.. Afterall they deserve some
      vacations from this cursed place... But soon they will be involved into something bigger Next Time.`,
  3,
  false,
  "logo_nt",
  `NT${halloween ? "/Halloween" : '/Remake'}`,
  "mega_trailer",
  "fboy2",
  halloween ? "PKG_NT_HALLOWEEN" : "Poof's Killergarten RT",
  ["RPG"],
  [`No matter if you're visiting it
        for first time or returning
        here after longer or shorter break,
        it's environment will warmly welcome you.
  
    As the facility lies unconcious under
    Poof's glorious toes, he need
    to acknowledge new situations
    and events accuring there.
        
  
     You will meet plenty of
     interesting characters for
     first, second or third
     time. Each having something
     funny to say.`,
     `Killergarten toys and personel aren't everything
      to worry about. There are multiple new
      enemies you can face, with more
      or less difficulty.
       
  
       Fighting enemies isn't senseless.
       They drop a bunch of useful items,
       exp and tokens you can use to
       win more fights and develop your party.
        
    
     Backgrounds during the battles are
     the most fabulous that poof's killergarten ever
     had. Increasing the battle experience.`,
     `The main four characters of
    the game are returning in
    all their fashion with
    brand new recruitment
    conditions.
     

   Each of the playable characters has
   it's own set of classes and
   abilities that can use
   to play different role in
   the party.

    Aside from that there are
    even more teammates you
    can use, try different
    compositions and strategies
    yourself.`,
    `There are 180+ achievable
   skills in the whole game.
   
    

  No matter if active or passive,
  each skill feels unique and you're
  the one to make the good use of 
  them.
   

  Over time party members will
  learn new exciting powers, so the 
  playstyle strategies would change
  as well.`,
  `Bossfights are crucial part of any RPG game,
and this one isn't exception.

Fight challenging bosses using
the best strategies and
strength of your party members
in order to discover new things
about the plot.

There are a lot bossfights in the game,
including secret mega bosses which
are very hard to defeat and
lead to unlocking the forbidden.`,
`The story is very important part
 of this game so alongside with new
 chapters, characters are progressing
 to new and unknown locations which are
 waiting to be explored.

Remember that some of them are
only lasting temporary and after
exiting them, you won't be able
to return next time...`,
`There is only one true ending...

 The world can't have different paths of development..
 Conclusion is needed.. Is required..
 So which one of them..

 The answer is.. The one you'll end
 up getting as the last one.. No
 matter the previous efforts.`],
  "aa_pkgnt_rurico15",
   true,
   4

));
gameArray.push(new Game(
  4,
  "World of Vampirim",
  `Land of Vampirim is an ancient place, full of lore, adventures, monsters,
      armies and magic. But such chaotic landscape can't last long right??
      That's why someone need to take a role of a hero!! Is that going to be you??
      There's only one person who can eradicate all the evil and save the day.`,
  3,
  false,
  "Wov_logo2",
  "WOV",
  "wov_cinematic_1",
  "vuctor1",
  "World of V",
  ["RPG"],
  [`Start your adventure visiting brand new strange world.
        Explore various landscapes and mysterious locations
        in chaotic World of Vampirim.
        It's up to you what path you'll end up going.`,
        `As the great Hero of Vampirim you'll face multiple
        opponents on your way of completing the grand
        prophecy. From small sever rat to monstrous flamebreathing
        dragon, ending on blood and virgin lusting vampires.
        There are thousands of enemies and each of them is
        unique in battle.`,
        `The most important attribute of a Hero, isn't
        his hammer or equipment he wields but the class.
        There are plenty of classes with amazing abilities
        and playstyles. Chose one that fits you the best.
        Let it be Paladin.. Please.`,
        `Land of Vampirim is full of epic treasure including
        the rarest of the rare, most mythical of mythics
        and legendariest of legendary??
        The point is that everyone will find something
        valuable, especially if they do looting expedition
        to a dungeon.
        Don't let thief goblin rob you.`,
        `Oh, good old bossfights. The best part of each RPG game.
        There are plenty of them to face in Vampirim.
        Each one is spectacular and full of drama and suspense.
        Bosses require lots of powerful skills, gear and strategy
        to be taken down and have their own special battle
        mechanics.`,
        `Find Me.. Please.. Only I can stop the Angel Age.`],
  "wov_meadow",
   false,
   10

));
gameArray.push(new Game(
  5,
  "Poof's Debovcherry Night",
  `You have opportunity to work in killergaten at night.
      And see how children are like when the sun goes down. Will you survive til morning??
      Can you maintain security in this facility of nightmares??`,
  3,
  true,
  "logo_night",
  "DN",
  "fnap",
  "grubiula1",
  "Poof's Killergarten RR",
  ["Horror"],
  [`No many people have witnessed mysteries of this ancient facility
       during the nightime. And yet, despite the fact it haven't been opened
       at such late time. You have opportunity to experience how its like to
       have a nightshift.`,
       `Once an unconquerable fortress, now it's your shellter against
       the nightmares haunting you down and wanting your demise.
       Its heavy gate will be your shield from their evergrowing
       animosity.`,
       `Observe the kids using security devices you wanted so badly
       to destroy as they are really the ones that should be feared.
       Each night there will be more and more trouble to look for, use
       cameras to command employees to defend yourself.`,
       `The majestic mirror located in the office for unknown purposes is
       the waygate to the world of spiritual. Use it to lure a soul, but
       be aware, not every of them has friendly interests.`,
       `It's such a horrible fate to be disolved into ashes and feeling like gravity isn't
       familiar anymore. It lures you, charms you, pulls you up inside, so fast like a
       bullet train. After passing nearby the brightening star you may feel light or heavy from
       your sins.`,
       `One two three, count with me.. There's a night number 3.. Where it is,
       don't ask me, find yourself there's a key...
       Hmmm... Hmm... Hmmm...`,
      `Something entirely evil has taken this place, dividing it from
       the brightening light, it's getting darker.. Only will get darker..
       I'm sorry for every terrible thing will happen from now on.....V`],
  "aa_pkgnt_shanty",
   false,
   9

));
gameArray.push(new Game(
  6,
  "World of Vampirim Underworld",
  `If you haven't visited land of vampirim yet, there's no need to hurry.
      Because today you'll be going underground following the magic fox into the pit of
      despair and madness. But maybe you're the lucky one and will find what've been hidden
      at the very end.`,
  3,
  false,
  "underwov",
  "WOVU",
  "wov_under",
  "uther1",
  "WOV_Underworld",
  ["AUTOBATTLER"],
  [`This time you won't be wandering on the large
        landscapes of vampirim's land, but underneath the earth.
        At the surface camp you'll have chance to prepare
        equipment you'll need for exploration of the dark caves.`,
        `Fighting underground critters isn't as simple as
        it should be. There are multiple hostile entities waiting
        for you and in order to survive you need to think
        and strategize. Align your allies into most
        suitable formation for battle.`,
        `There are multiple choices and ways ahead of you.
        But there's only one leading to true victory!! Choose wisely
        and depending on circumstances, be aware to not pick the
        wrong one.`,
        `Despite the fact that battles play automatically, they
        are still intense and epic. Your heroes depending on rarity
        and quality are casting powerfull spells and abilities
        in order to win against the odds. Observe their mighty
        struggles against most dangerous monsters.`,
        `Those battles are especially difficult and full of
        tension. Prepare well for them or else you'll be doomed
        forever. They will test your strength and prove if you're really
        a mighty warrior.`,
        `Hero of vampirim?? Come along with me. In this world full of
        vampiric fangs, there's a simple solution, represented by either zero or one.`],
  "wov_cave",
   false,
   7

));
gameArray.push(new Game(
  7,
  "Poof's Killergarten Wishful Thinking",
  `World of Poof's Killergarten has been sucked into the abyss.
      But what was the turning point that made it all
      gone this way. See retelling of the original story
      from different time, different struggles and similar
      perspectives. But this time, jump yourself to survival.`,
  5,
  false,
  "wt",
  "WT",
  "wishful",
  "capcake1",
  "Poof's Killergarten Wishful Thinking",
  ["PLATFORMER"],
  [`If you're new, meet the faces of killergarten and join them
        into this abstract and absurd world but if you aren't new. You
        should be concerned how we're still here despite what happened.`,
        `This time instead of having turns and skills you are
        put in situation where jumping and moving freely are your
        tools to deal with everything. However don't worry it's not that bad.`,
        `There are bosses!! As in every poof's killergarten game, each
        unique in their mechanics and require different strategy and
        skills to be defeated.`,
        `On your way there will be plenty of those.
        Just remember to stay calm and prepare for what is yet to come.`,
        `In this one there are actual real and fresh cutscenes delivered to you
        with sound and passion. I wish for as many eyes as possible to feast upon them.
        But only ones with sharp vision will notice the secrets hidden within the motion
        of events.`,
        `Ah characters, there would be no party without those. Later ones
        are especially good.`,
        `There are a lot of passwords in this one.`],
  "wishful",
   false,
   6

));
gameArray.push(new Game(
  8,
  "Creepy Pasts + DLC",
  `See for yourself...`,
  5,
  false,
  "clownjojo",
  "CP",
  "cdlc",
  "jojo",
  "CreepyPasts",
  ["SURVIVAL", "HORROR"],
  [  `How things came to this.`,
        `Such preserved secret of darkness.`,
        `Leaked before your very eyes.`,
        `Purpose of life isn't just surviving but overcoming your deepest fears.`,
        `Jump into this shady gray world for yourself and challenge it's greedy nature.`,
        `This story will unfold who you really are, maybe.`],
  "aa_creepy",
   true,
   1

));

gameArray.push(new Game(
  9,
  "Cronic",
  `You are volunteer who's goal is collecting 8 documents for some shady person wanting to know what mystery is hidden behind the CRONIC.`,
  4,
  false,
  "redcronic",
  "CR",
  "cronic_trail",
  "cronic",
  "Cronic",
  ["SURVIVAL","HORROR"],
  [ `Your task is to find 8 documents, easy right?`,
        `Clues to what??.`,
        `The pink ones are harmless, compared to everything else.`,
        `Stay on your legs, breath strong.`,
        `Just tell me what it is!!`,
        `It gets intense here!! Who the hell turned off the lights!`,
        `Time has changed forever.`],
  "cronic_home",
   false,
   5

));


gameArray.push(new Game(
  10,
  "Kene & Sabrini",
  `This is beautiful story of true love. Two fates aligned together in this liminal world.
  They both are just like two droplets of water.`,
  5,
  false,
  "kslogo",
  "K&S2",
  "kenebrini_trailer",
  "kenebrini",
  "Kene & Sabrini",
  ["RPG","SURVIVAL","HORROR"],
  [` Words like strange, weird and unique aren't enough to explain what you're about to witness...`,
    `The game isn't the esiest. You must take advantage of your power to control all five senses to survive.`,
    `Only you can decide their fate.`,
    `You're not prepared for what comes next...`,
    `Indeed... You will be consumed by your childhood traumas.`,
    `There's nothing more beautiful than love right??`,
    `Not everything is as bright. Especially at this side of the garden.`],
  "ksbackground2",
  true,
  2

));

gameArray.push(new Game(
  12,
  "Hello Bunny",
  `Follow the Bunny...`,
  3,
  false,
  "erie",
  "MV",
  "bunny",
  "Dorothy",
  "HelloBunny",
  ["SURVIVAL", "HORROR"],
  [  `...`,
    `...`,
        `...`,
        `...`,
        `...`,
        `...`,
        `...`],
  "aa_mwov",
   true,
   0

));

let rng = Math.ceil(Math.random() * 5);
if(rng == 1){
gameArray.push(new Game(
  11,
  "Fractal Alien Calimaria",
  `Fight for your life in endless expanse of space and defeat Space Devil!!!`,
  2,
  false,
  "cali",
  "FA",
  "calimaria",
  "spacedevil",
  "FA_Calimaria",
  ["SHOOTER","ROGUELIKE"],
  [`And either freezing or exploding...`,
    `Each one having unique shooting and piloting abilities.`,
    `Or else they will take you down.`,
    `Each has unique ability!!!`,
    `They are progressively larger!!!`,
    `What message?`,
    `...`],
  "fractal_facility",
  true,
  2

));

}

function GameCard(id,img,link,title,description){
  this.id = id;
  this.img = img;
  this.link = link;
  this.title = title;
  this.description = description; 
}

const gameCardsArray = [];

gameCardsArray.push(new GameCard(
   1,
  "/pictures/graphics/murgarten.jpg",
   '/games/:3',
  "Murdergarten Chapter",
  `Dir Gryb created murdergarten in order to
  create most perfect and loyal subordinate,
  but not without paying cruel price, stop her
  before it's too late.`
));
gameCardsArray.push(new GameCard(
  2,
  "/pictures/graphics/wishful.jpg",
   '/games/:7',
  "Most Difficult Game Ever",
  `By far the hardest game in the
  poof's killergarten series offers
  platforming experience and beating it is wishful thinking itself.`
));
gameCardsArray.push(new GameCard(
  3,
  "/pictures/graphics/creepy.jpg",
   '/games/:8',
  "You are wanted!!",
  `In this game there's no tutorial or helping hand.
  Just you and your trial and error survival run.`
));

const router = createBrowserRouter([
  {path:"/",element:<App xmas={xmas} halloween={halloween} horrorGames={horrorGameArray} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/games",element:<Games xmas={xmas} horrorGames={horrorGameArray} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/games-horror",element:<GamesHorror xmas={xmas} horrorGames={horrorGameArray} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/games-horror/:id",element:<GamesHorror horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/games/:id",element:<Games xmas={xmas} horrorGames={horrorGameArray} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/fateItems",element:<FateItems horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/gallery",element:<Gallery horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/updates",element:<Updates horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
  {path:"/passwords",element:<Passwords horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
      {path:"/playing",element:<Playing horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
    {path:"/playing/:id",element:<Playing horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>},
      {path:"*",element:<App horrorGames={horrorGameArray} xmas={xmas} halloween={halloween} games={gameArray} gameCards={gameCardsArray} season={season}/>}
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

